/* Angular modules */
import {Component, OnInit} from '@angular/core';
/* ngx modules */
import {SessionStorage, SessionStorageService} from 'ngx-webstorage';
/* 3rd parties libraries */
/* app modules */
import {Item, Status} from '../../project/shared/project-model';
import {User} from '../../shared/user/user';
import {LoggerService} from '../../shared/logging/logger.service';

@Component({
  standalone: false,
  selector: 'app-validity-period',
  templateUrl: './validity-period.component.html',
  styleUrls: ['./validity-period.component.less']
})
export class ValidityPeriodComponent implements OnInit {

  @SessionStorage()
  currentItemct: Item;

  @SessionStorage()
  user: User;

  localeDate: string;
  validityDate: string;
  quoteIsValid: boolean;
  isToDisplay = false;

  constructor(private logger: LoggerService,
              private sessionStorageService: SessionStorageService) {
  }

  ngOnInit() {
    this.logger.debug('ValidityPeriodComponent init()');

    // ngx-webstorage observe() only fires on writes, not on subscribe — check current state immediately
    this.updateValidityPeriodState();

    this.sessionStorageService.observe('currentItemct')
        .subscribe(() => this.updateValidityPeriodState());
  }

  private updateValidityPeriodState() {
    if (this.currentItemct && this.currentItemct.status === Status.quoted) {
      if (this.currentItemct.date) {
        const locale = this.user.preferredLanguage || 'en-US';
        const options: Intl.DateTimeFormatOptions = {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        };
        this.localeDate = new Date(this.currentItemct.date)
          .toLocaleDateString(locale, options);
        this.validityDate = new Date(this.currentItemct.dateValidityQuotation)
          .toLocaleDateString(locale, options);
        // Is current date after validity of bom
        this.quoteIsValid = new Date(this.currentItemct.dateValidityQuotation) > new Date();
        this.isToDisplay = true;
      }
    } else {
      this.isToDisplay = false;
    }
  }

}
